import { useTranslation } from 'react-i18next';
import { Button } from 'react-aria-components';



interface ToolbarProps {
	insertNbsp: () => void;
}


export const Toolbar = (props: ToolbarProps) => {
	const { insertNbsp } = props;
	const { t } = useTranslation('admin');

	return (
		<div className='content-toolbar'>

			<Button
				className='app-admin-button disable-selection'
				onPress={() => {
					insertNbsp();
				}}>
				{t('pages.article.articleForm.content.insertNbspButton')}
			</Button>

		</div>
	);
};